import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Tournament = () => {
  return (
    <>
      {/* HERO SECTION */}
      <section className="services-hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>

        <Container className="position-relative z-3 h-100">
          <Row className="h-100 align-items-center justify-content-center">
            <Col xs={12} lg={10} xl={8} className="text-center text-white">
              <h1 className="hero-title mb-4">
                Indian Simulator Golf Open 2027
              </h1>
              <p className="hero-subtitle mb-5">
                A premier tournament organized by Golf4International on behalf of SIF Group, exclusively for amateur golf players.
              </p>

              <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                <a href="#register" className="btn btn-gold-filled btn-lg">
                  Register Now
                </a>
                <a href="#details" className="btn btn-gold btn-lg">
                  View Details
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* OVERVIEW */}
      <section id="details" className="section-padding">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="section-title">Tournament Overview</h2>
              <p className="section-subtitle">
                Open strictly for amateur players with world-class tournament experience
              </p>
            </Col>
          </Row>

          <Row className="g-4 text-center">
            <Col md={6}>
              <div className="card-modern p-4 h-100">
                <h4 className="text-gold">Eligibility</h4>
                <p>Open strictly for Amateur Players only</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="card-modern p-4 h-100">
                <h4 className="text-gold">Participation</h4>
                <p>192 Registered Players at each centre</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>


      {/* INCLUSIONS */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="section-title">Tournament Inclusions</h2>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6}>
              <div className="card-modern p-4 h-100">
                <h4 className="text-gold">🎯 Playing & Prize Structure</h4>
                <ul>
                  <li>Official Playing Rights for the Tournament</li>
                  <li>Tangible Prizes worth approximately ₹50 Lakhs</li>
                  <li>Intangible Benefits worth approximately ₹18 Crores</li>
                </ul>
              </div>
            </Col>

            <Col md={6}>
              <div className="card-modern p-4 h-100">
                <h4 className="text-gold">🏆 Awards & Recognition</h4>
                <ul>
                  <li>Trophies & Mementos for Winners and Runners-Up</li>
                  <li>Goodie Jute Bag for all registered players, including:</li>
                  <ul>
                    <li>Branded T-Shirt</li>
                    <li>Golf Cap</li>
                    <li>Sleeve of Golf Balls (for selected winners & sponsors)</li>
                    <li>Golf Gloves (for selected winners & sponsors)</li>
                    <li>Perfume Gift (for selected winners & sponsors)</li>
                  </ul>
                </ul>
              </div>
            </Col>

            <Col md={6}>
              <div className="card-modern p-4 h-100">
                <h4 className="text-gold">🍽️ Food & Beverage</h4>
                <ul>
                  <li>Meal of the Day for players and attendees (as per schedule)</li>
                  <li>Tea & Coffee (as per schedule)</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* SCHEDULE */}
      <section className="section-padding">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="section-title">Tournament Schedule & Key Dates</h2>
            </Col>
          </Row>

          <Row className="g-3">
            {[
              "21 May 2027 – Selection of Ground on Garmin (By Draw)",
              "23 May 2027 – Draw of Lots (Who, Where & When Players Will Play) ",
              "24–29 May 2027 – Preliminary Rounds (9 Holes – All Players) ",
              "27 May 2027 – Selection of Different Ground on Garmin (By Draw)",
              "29 May 2027 – Final Round Draw of Lots ",
              "30 May 2027 – Final Round (18 Holes – Top 100 Players)  "
            ].map((item, i) => (
              <Col md={6} key={i}>
                <div className="card-modern p-3">{item}</div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* EXCLUSIONS */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="section-title">Tournament Exclusions</h2>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            <Col md={4}>
              <div className="card-modern p-4 text-center">
                <p>Simulator Fee: ₹250 (9 Holes)</p>
                <p>Simulator Fee: ₹500 (18 Holes)</p>
                <p>94 players listed on the official PGTI website are NOT eligible</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FEES */}
      <section className="section-padding">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="section-title">Registration Fees</h2>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            <Col md={4}>
              <div className="card-modern p-4 text-center">
                <h4>Women</h4>
                <p>Over 60 → ₹1,199</p>
                <p>Under 60 → ₹1,299</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="card-modern p-4 text-center">
                <h4>Men</h4>
                <p>Over 60 → ₹1,399</p>
                <p>Under 60 → ₹1,499</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="card-modern p-4 text-center">
                <h4>Children</h4>
                <p>Up to 15 Years → ₹1,099</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CONTACT */}
      <section id="register" className="section-padding bg-soft-sage">
        <Container>
          <Row className="text-center">
            <Col>
              <div className="newsletter-card">
                <h3 className="text-white">Register Now</h3>
                <p className="newsletter-text">
                  Contact: 8610788265 / 8920152532 <br />
                  Email: accounts@sifgroup.org
                </p>

                <a
                  href="https://forms.gle/HvD4v7tsEnNKo1uM6"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-gold-filled btn-lg"
                >
                  Open Registration Form
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CSS Styles */}
      <style jsx>{`
        /* Hero Section - Standardized with other pages */
        .services-hero-section {
          height: 70vh;
          min-height: 600px;
          background: linear-gradient(rgba(31, 61, 43, 0.6), rgba(31, 61, 43, 0.75)), 
                     url('https://magazine.fortevillageresort.com/wp-content/uploads/2021/05/unsplash21039401-ufcDM0ApEBs-unsplash-scaled.jpg') center/cover no-repeat;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding-top: 80px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
          z-index: 1;
        }
        
        .hero-pattern {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at center, rgba(181, 154, 90, 0.1) 0%, transparent 70%);
          animation: pulse 4s ease-in-out infinite;
          z-index: 1;
        }
        
        .hero-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: #B59A5A;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .hero-subtitle {
          font-size: clamp(1rem, 2.5vw, 1.5rem);
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.95);
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          margin-bottom: 2.5rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        .hero-cta {
          position: relative;
          z-index: 2;
        }
        
        /* Button Styles - Consistent with other pages */
        .btn-gold-filled {
          background-color: #B59A5A;
          color: #1F3D2B;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold-filled:hover {
          background-color: #d4b56e;
          color: #1F3D2B;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        .btn-gold {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
          color: #B59A5A;
          border: 2px solid #B59A5A;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold:hover {
          background-color: rgba(181, 154, 90, 0.2);
          color: #d4b56e;
          border-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        /* Section Styles */
        .section-padding {
          padding: clamp(3rem, 6vw, 5rem) 0;
        }
        
        .section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.2;
          font-family: 'Playfair Display', serif;
        }
        
        .section-subtitle {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        /* Service Cards */
        .service-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .service-img {
          height: clamp(200px, 30vw, 250px);
          width: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        
        .service-img-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.7) 100%);
        }
        
        .service-icon-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }
        
        .service-title {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
          font-family: 'Playfair Display', serif;
        }
        
        .service-card:hover .service-title {
          color: #B59A5A;
          transition: color 0.3s ease;
        }
        
        .service-description {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
        }
        
        .service-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .service-features li {
          margin-bottom: 0.5rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        .feature-check {
          color: #B59A5A;
          font-weight: 600;
        }
        
        .service-footer {
          border-top: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .service-price {
          font-size: clamp(0.8rem, 1.5vw, 0.9rem);
        }
        
        /* Newsletter Card - Consistent with other pages */
        .newsletter-card {
          background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
          color: white;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: 15px;
          width: 100%;
        }
        
        .newsletter-icon {
          width: clamp(60px, 10vw, 80px);
          height: clamp(60px, 10vw, 80px);
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 3vw, 2rem);
          margin: 0 auto 1.5rem;
        }
        
        .newsletter-text {
          opacity: 0.9;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          margin-bottom: 2rem;
          font-weight: 400;
        }
        
        /* Tech Cards */
        .tech-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .tech-card:hover {
          transform: translateY(-5px);
        }
        
        .tech-img {
          height: clamp(180px, 25vw, 220px);
          width: 100%;
          background-size: cover;
          background-position: center;
        }
        
        .tech-content {
          flex: 1;
        }
        
        .tech-description {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
        }
        
        .tech-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .tech-features li {
          margin-bottom: 0.5rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        /* FAQ Section */
        .faq-section {
          background: white;
          border-radius: 12px;
        }
        
        .accordion-button-custom {
          background-color: transparent !important;
          color: #1F3D2B !important;
          font-size: 1rem;
          padding: 1.5rem 0;
          border: none !important;
          box-shadow: none !important;
          font-weight: 500;
        }
        
        .accordion-button-custom:not(.collapsed) {
          color: #B59A5A !important;
        }
        
        /* Package Cards */
        .package-card {
          position: relative;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          border: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .package-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .most-popular {
          border: 2px solid #B59A5A;
          box-shadow: 0 10px 30px rgba(181, 154, 90, 0.15);
        }
        
        .popular-badge {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          text-align: center;
          padding: 0.5rem;
          background: linear-gradient(90deg, #B59A5A 0%, #d4af37 50%, #B59A5A 100%);
          color: white;
          font-weight: 700;
          font-size: clamp(0.7rem, 1.5vw, 0.85rem);
          letter-spacing: 1px;
          text-transform: uppercase;
          z-index: 2;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .package-header {
          background: rgba(31, 61, 43, 0.02);
          border-bottom: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .package-name {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
        }
        
        .most-popular .package-name {
          color: #B59A5A;
        }
        
        .package-type {
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
        }
        
        .package-price {
          background: rgba(31, 61, 43, 0.03);
        }
        
        .package-amount {
          font-size: clamp(2rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
        }
        
        .most-popular .package-amount {
          color: #B59A5A;
        }
        
        .package-period {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        .package-features-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .package-features-list li {
          margin-bottom: 0.75rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        .feature-icon {
          color: #B59A5A;
          flex-shrink: 0;
          margin-top: 2px;
        }
        
        .package-cta {
          border-top: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .package-badge {
          display: inline-block;
          background: #B59A5A;
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }
        
        .package-comparison {
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(181, 154, 90, 0.2);
        }
        
        .package-comparison span {
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          color: #666;
        }
        
        /* Text Colors */
        .text-gold {
          color: #B59A5A;
        }
        
        .text-green {
          color: #1F3D2B;
        }
        
        .text-muted {
          color: #666;
        }
        
        /* Background Colors */
        .bg-soft-sage {
          background-color: #f0f7f3;
        }
        
        /* Animations */
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        /* Responsive Button Sizes */
        .btn-lg {
          padding: clamp(10px, 2vw, 12px) clamp(20px, 3vw, 32px);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        /* Responsive Grid Gaps */
        .g-4 {
          --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
          --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
        }
        
        /* ================= MOBILE RESPONSIVE FIXES ================= */
        
        /* Extra Small Devices - Mobile Phones */
        @media (max-width: 576px) {
          .services-hero-section {
            height: 65vh;
            min-height: 500px;
            padding-top: 100px;
          }
          
          .hero-title {
            margin-bottom: 1rem;
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            margin-bottom: 2rem;
            font-size: 1.1rem;
          }
          
          .hero-cta {
            flex-direction: column;
            gap: 1rem;
            margin-top: 20px;
          }
          
          .hero-cta .btn {
            width: 100%;
            padding: 14px 20px;
            font-size: 1rem;
          }
          
          .service-img {
            height: 200px;
          }
          
          .tech-img {
            height: 180px;
          }
          
          .service-icon-badge {
            width: 45px;
            height: 45px;
            font-size: 1.3rem;
          }
          
          .popular-badge {
            padding: 0.4rem;
            font-size: 0.7rem;
            height: 35px;
          }
          
          .package-header {
            padding-top: calc(1rem + 35px) !important;
          }
          
          .package-amount {
            font-size: 2rem;
          }
          
          .btn-lg {
            padding: 14px 20px;
          }
        }
        
        /* Small Devices - Larger Mobile Phones */
        @media (min-width: 577px) and (max-width: 768px) {
          .services-hero-section {
            height: 70vh;
            min-height: 550px;
            padding-top: 90px;
          }
          
          .hero-title {
            font-size: 2.8rem;
          }
          
          .hero-subtitle {
            font-size: 1.3rem;
          }
          
          .hero-cta {
            margin-top: 10px;
          }
          
          .service-img {
            height: 220px;
          }
          
          .tech-img {
            height: 200px;
          }
          
          .popular-badge {
            height: 38px;
          }
          
          .package-header {
            padding-top: calc(1.25rem + 38px) !important;
          }
        }
        
        /* Medium Devices - Tablets */
        @media (min-width: 769px) and (max-width: 992px) {
          .services-hero-section {
            height: 75vh;
            min-height: 600px;
            padding-top: 80px;
          }
          
          .service-img {
            height: 230px;
          }
          
          .tech-img {
            height: 210px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Large Devices - Desktops */
        @media (min-width: 993px) and (max-width: 1199px) {
          .services-hero-section {
            height: 80vh;
            min-height: 650px;
            padding-top: 60px;
          }
          
          .service-img {
            height: 240px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Very Large Screens */
        @media (min-width: 1200px) {
          .services-hero-section {
            height: 85vh;
            min-height: 700px;
            padding-top: 40px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Landscape Orientation on Mobile */
        @media (max-height: 600px) and (orientation: landscape) {
          .services-hero-section {
            height: 100vh;
            min-height: 400px;
            padding-top: 80px;
          }
          
          .hero-title {
            font-size: 2rem;
            margin-bottom: 0.5rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }
          
          .service-img {
            height: 180px;
          }
          
          .tech-img {
            height: 160px;
          }
          
          .popular-badge {
            height: 35px;
            font-size: 0.65rem;
          }
          
          .package-header {
            padding-top: calc(1rem + 35px) !important;
          }
        }
        
        /* Accessibility: Focus states */
        button:focus,
        input:focus,
        a:focus {
          outline: 2px solid #B59A5A;
          outline-offset: 2px;
        }
        
        /* Print styles */
        @media print {
          .hero-cta,
          .newsletter-card,
          .package-cta {
            display: none !important;
          }
          
          .services-hero-section {
            padding-top: 0;
            height: auto;
            min-height: auto;
          }
        }
      `}</style>
    </>
  );
};

export default Tournament;